module.exports = __webpack_public_path__ + "static/media/church-school.9bd9b22e.jpg";